import axios from "../utils/axios.wrapper";

// Get all purchases
export const getAllPurchases = async () => {
  const { data } = await axios.get("/purchase");
  return data.items || data;
};

// Get purchase by ID
export const getPurchaseById = async (id) => {
  const { data } = await axios.get(`/purchase/${id}`);
  return data;
};

// Create new purchase
export const createPurchase = async (purchaseData) => {
  const { data } = await axios.post("/purchase/create", purchaseData);
  return data;
};

// Update purchase
export const updatePurchase = async (id, purchaseData) => {
  const { data } = await axios.put(`/purchase/${id}`, purchaseData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return data;
};

// Soft delete purchase
export const softDeletePurchase = async (id) => {
  const { data } = await axios.delete(`/purchase/${id}`);
  return data;
};

// Hard delete purchase
export const hardDeletePurchase = async (id) => {
  const { data } = await axios.delete(`/purchase/hard/${id}`);
  return data;
};

export const getPurchasesByDateRange = async (filter) => {
  const response = await axios.post('/purchase/daterange', filter);
  const data = response.data;

  return {
    items: data?.items ?? data ?? [],
    totalCount: data?.totalCount ?? data ?? 0,
  };
};

export const purchaseService = {
  getAllPurchases,
  getPurchaseById,
  createPurchase,
  updatePurchase,
  softDeletePurchase,
  hardDeletePurchase,
  getPurchasesByDateRange,
};
